import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpContext} from "@angular/common/http";
import {getEndpoints} from "~core/constants/endpoints.constants";
import {OrderRequest} from "~features/checkout/models/order-request.model";
import {map, Observable} from "rxjs";
import {OrderResponse,OrderError} from "~features/checkout/models/order-response.model";
import {COMPANY_AUTH} from "~core/constants/context-token.constants";
import {ShippingResponse} from "~features/checkout/models/shipping-response.model";

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  private http = inject(HttpClient);
  private readonly endpoints = getEndpoints();

  calculateorder(payload: OrderRequest): Observable<any> {
    console.log('Sending order request with payload:', payload);
    const _orderurl = this.endpoints.order.v2.padorder
    return this.http
        .post<OrderResponse|OrderError>(_orderurl, payload)
        .pipe(map((response) => this.handleOrderResponse(response)));
  }

  private handleOrderResponse(response: OrderResponse|OrderError): boolean {
    if ('ok' in response) {
      if ('error' in response ) {
        throw new Error("Errore nell'invio dell'ordine: "+ response.error);
      }
      return response.ok;
    }
    throw new Error('Errore generico');
  }


}
